<template>
    <div class="store">
        <div class="nav-topbar">
            <div class="mobiles-nav-list">
                <a class="nav-backs" @click="backs()"> 首页 </a>
                <a class="nav-items">商城 </a>
            </div>
            <div class="nav-list">
                <a class="nav-backs" @click="backs()"> 首页 </a>
                <a class="nav-items">商城 </a>
            </div>
        </div>

        <div class="good-centers">
            <div class="calss-top-pc">
                <el-input type="text" size="small" v-model="searchText" style="width:380px; float: left" clearable
                    placeholder="请输入产品名字"></el-input>
                <el-button type="warning" @click="init()" style="width: 68px; float: left; margin-left:12px;"
                    size="small">搜索</el-button>
            </div>

            <div class="calss-top-mobile">
                <el-input type="text" size="small" v-model="searchText" style="width:80%; float: left" clearable
                    placeholder="请输入产品名字"></el-input>
                <el-button type="warning" @click="init()" style="width: 19%; float: left; margin-left:1%;"
                    size="small">搜索</el-button>
            </div>
            <div class="class-list">
                <div class="class-items" v-for="(val, index) in ClistInfo.children"
                    :class="{ 'active': active == val.id }" @click="changeActive(val.id)"><span>{{ val.name }}</span>
                </div>
            </div>

            <div class="goods-lists">
                <div class="goods-centers">
                    <div class="goods-items" v-for="(val, index) in List" @click="navPage(val)">
                        <div class="goods-pic">
                            <img :src="baseUrls + val.image" width="100%" height="auto" :title="val.title"></img>
                        </div>
                        <div class="goods-text">
                            <div class="goods-ti" :title="val.title">
                                <span class="goods-sups" v-if="val.iscustomized==1">可定制</span>
                                <span class="goods-sup">超值购</span>
                                {{ val.title }}
                            </div>
                            <div class="goods-hot">近期新品榜TOP{{ index + 1 }}</div>
                            <div class="goods-pr">￥
                                <span class="max">{{ val.price[0] }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page-el">
                    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
                        :page-size="pageSize" layout="total,prev,pager,next" :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" :width="width">
            <div style="text-align: center;">
                <img src="../assets/imgs/code.jpg" style="width: 80%;height: auto;"></img>
                <div class="font">请打开官方小程序购买o(*￣▽￣*)ブ</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="warning" size="mini" @click="dialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import ApiCon from '../util/Api/index'
export default {
    name: 'store',
    data() {
        return {
            width:'30%',
            List: [
                {
                    price: [0.00]
                }

            ],
            dialogVisible: false,
            ClistInfo: {
                children: []
            },
            baseUrls: "https://www.sosunlive.com",
            searchText: '',
            active: '',
            pageSize: 10,
            currentPage: 1,
            total: 0,
            page: 1,
        }
    },
    created() {
        let self = this
        if (window.screen.width > 1280) {
            this.width = "22%";
        } else {
            this.width = "95%";
        }
        self.init()
        self.getCLists()
    },
    methods: {
        backs: function () {
            this.$router.push("/index");
        },
        navPage(val) {
            //'/GoodDetail/'+val.id
            let self = this
            self.dialogVisible = true
            //self.navToPage('/GoodDetail/' + val.id)
        },
        navToPage(val) {
            let self = this;
            self.$router.push(val);
        },
        changeActive(val) {
            let self = this
            self.active = val
            self.init()
        },
        handleCurrentChange(e) {
            let self = this
            self.page = e
            self.init()

        },
        getCLists() {
            let self = this
            let id = ''
            this.$api.mall.getCList(id).then((res) => {
                //self.active=res.data.children[0].id
                self.ClistInfo = res.data
                let info = {
                    name: '商品推荐',
                    id: ''
                }
                self.ClistInfo.children.unshift(info)

            })
        },
        init: function () {
            /**
                sort: Sort,
                order: Order,
                category_id: !keyword ? categoryId : '',
                list_rows,
                keyword: keyword,
                page,
             */
            let self = this
            let params = {
                sort: '',
                order: '',
                category_id: self.active,
                list_rows: '',
                keyword: '',
                page: self.page,
            }
            self.List = []
            this.$api.mall.getGoodList(params).then((res) => {
                let data = res.data.data
                self.List = res.data.data
                self.total = res.data.total
            })

        }
    }
}
</script>

<style lang="scss" scoped>
@media (max-width: 8000px) and (min-width: 1024px) {
    .store {
        width: 100%;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        box-sizing: border-box;

        .font {
            width: 100%;
            margin: 10px auto;
            padding: 0px;
            color: #b08d6a;
            font-size: 16px;
            box-sizing: border-box;
        }

        .good-centers {
            width: 980px;
            overflow: hidden;
            margin: 58px auto;
            padding: 0px;
            box-sizing: border-box;

            .goods-lists {
                width: 100%;
                overflow: hidden;
                margin: 10px auto;
                padding: 0px;
                box-sizing: border-box;

                .goods-centers {
                    width: 100%;
                    overflow: hidden;
                    margin: 0px auto;
                    padding: 0px;
                    box-sizing: border-box;
                }

                .page-el {
                    width: 100%;
                    overflow: hidden;
                    margin: 0px auto;
                    padding: 0px;
                    box-sizing: border-box;

                }

                .goods-items:hover {
                    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
                }

                .goods-items {
                    width: 24%;
                    overflow: hidden;
                    margin-left: 1%;
                    margin-top: 6px;
                    margin-bottom: 6px;
                    padding: 0px;
                    background: #fff;
                    text-align: center;
                    border-radius: 12px;
                    box-sizing: border-box;
                    float: left;
                    cursor: pointer;
                    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);

                    .goods-text {
                        width: 100%;
                        overflow: hidden;
                        margin: 0px auto;
                        box-sizing: border-box;
                        padding: 8px;
                        .goods-sups {
                            background: #b08d6a;
                            color: #fff;
                            padding-left: 10px;
                            padding-right: 10px;
                            line-height: 22px;
                            margin-right: 6px;
                            text-align: center;
                            overflow: hidden;
                            border-radius: 10px;
                        }

                        .goods-sup {
                            background: #fd3d51;
                            color: #fff;
                            padding-left: 10px;
                            padding-right: 10px;
                            line-height: 22px;
                            text-align: center;
                            overflow: hidden;
                            border-radius: 10px;
                        }

                        .goods-hot {
                            width: 100%;
                            margin: 0px auto;
                            padding: 0px;
                            color: #b08d6a;
                            line-height: 22px;
                            text-align: left;
                        }

                        .goods-ti {
                            width: 100%;
                            margin: 0px auto;
                            padding: 0px;
                            word-break: break-all;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }

                        .goods-pr {
                            width: 100%;
                            overflow: hidden;
                            margin: 0px auto;
                            text-align: left;
                            padding: 0px;
                            font-weight: 500;
                            color: #f83b4a;
                            line-height: 22px;

                            .max {
                                font-size: 16px;
                                white-space: nowrap;
                            }
                        }
                    }

                    .goods-pic {
                        /**
                        width: 100%;
                        overflow: hidden;**/
                        width: 235px;
                        height: 314px;
                        display: flex;
                        justify-content: center;
                        /* 水平居中 */
                        align-items: center;
                        /* 垂直居中 */
                        margin: 0px auto;
                        padding: 0px;
                        border-radius: 12rpx;
                        box-sizing: border-box;
                    }
                }
            }

            .class-list {
                width: 100%;
                overflow: hidden;
                margin: 10px auto;
                padding: 0px;

                .active {
                    color: #ff4b53 !important;
                    font-weight: 600;

                    span {
                        border-bottom: 2px solid #ff4b53;
                        line-height: 25px;
                        display: inline-block;
                    }
                }

                .class-items {
                    padding-left: 12px;
                    padding-right: 12px;
                    line-height: 25px;
                    font-size: 14px;
                    overflow: hidden;
                    margin: 0px auto;
                    cursor: pointer;
                    box-sizing: border-box;
                    float: left;
                }
            }

            .calss-top-mobile {
                display: none;
            }

            .calss-top-pc {
                width: 100%;
                overflow: hidden;
                margin: 0px auto;
            }
        }


        .nav-topbar {
            width: 100%;
            overflow: hidden;
            background: #ffe url('/imgs/fade.png') top center repeat-x;
            position: fixed;
            top: 0px;
            left: 0px;
            z-index: 10;

            .mobiles-nav-list {
                display: none;
            }

            .nav-list {
                width: 980px;
                overflow: hidden;
                margin: 0px auto;

                .searchTexts {
                    width: 50%;
                    float: right;
                    overflow: hidden;
                    margin: 6px auto;
                }

                .nav-backs {
                    text-decoration: none;
                    display: block;
                    font-weight: 400;
                    overflow: hidden;
                    color: maroon;
                    line-height: 45px;
                    text-align: center;
                    float: left;
                    cursor: pointer;
                }

                .nav-items {
                    text-decoration: none;
                    display: block;
                    margin-left: 12px;
                    font-weight: 400;
                    overflow: hidden;
                    color: maroon;
                    line-height: 45px;
                    text-align: center;
                    float: left;
                }

                .nav-backs:hover {
                    color: red !important;
                    text-decoration: underline;
                }
            }
        }
    }
}

@media (max-width: 1024px) and (min-width: 320px) {
    .store {
        width: 100%;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        box-sizing: border-box;

        .page-el {
            width: 100%;
            overflow: hidden;
            margin: 0px auto;
            padding: 0px;
            box-sizing: border-box;
        }

        .good-centers {
            width: 100%;
            overflow: hidden;
            margin: 48px auto auto auto;
            padding: 0px;
            box-sizing: border-box;


            .goods-lists {
                width: 98%;
                overflow: hidden;
                margin: 10px auto;
                padding: 0px;
                box-sizing: border-box;

                .goods-items {
                    width: 47%;
                    overflow: hidden;
                    margin-left: 2%;
                    margin-top: 6px;
                    margin-bottom: 6px;
                    padding: 0px;
                    background: #fff;
                    text-align: center;
                    border-radius: 12px;
                    box-sizing: border-box;
                    float: left;
                    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);

                    .goods-text {
                        width: 100%;
                        overflow: hidden;
                        margin: 0px auto;
                        box-sizing: border-box;
                        padding: 8px;
                        .goods-sups {
                            background: #b08d6a;
                            color: #fff;
                            padding-left: 10px;
                            padding-right: 10px;
                            line-height: 22px;
                            margin-right: 6px;
                            text-align: center;
                            overflow: hidden;
                            border-radius: 10px;
                        }

                        .goods-sup {
                            background: #fd3d51;
                            color: #fff;
                            padding-left: 10px;
                            padding-right: 10px;
                            line-height: 22px;
                            text-align: center;
                            overflow: hidden;
                            border-radius: 10px;
                        }

                        .goods-hot {
                            width: 100%;
                            margin: 0px auto;
                            padding: 0px;
                            color: #b08d6a;
                            line-height: 22px;
                            text-align: left;
                        }

                        .goods-ti {
                            width: 100%;
                            margin: 0px auto;
                            padding: 0px;
                            word-break: break-all;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }

                        .goods-pr {
                            width: 100%;
                            overflow: hidden;
                            margin: 0px auto;
                            text-align: left;
                            padding: 0px;
                            font-weight: 500;
                            color: #f83b4a;
                            line-height: 22px;

                            .max {
                                font-size: 16px;
                                white-space: nowrap;
                            }
                        }
                    }

                    .goods-pic {
                        /**
                        width: 100%;
                        overflow: hidden;**/
                        width: 198px;
                        height: 264px;
                        display: flex;
                        justify-content: center;
                        /* 水平居中 */
                        align-items: center;
                        /* 垂直居中 */
                        margin: 0px auto;
                        padding: 0px;
                        border-radius: 12rpx;
                        box-sizing: border-box;
                    }
                }
            }

            .class-list {
                width: 98%;
                overflow: hidden;
                margin: 10px auto;
                padding: 0px;

                .active {
                    color: #ff4b53 !important;
                    font-weight: 600;

                    span {
                        border-bottom: 2px solid #ff4b53;
                        line-height: 25px;
                        display: inline-block;
                    }
                }

                .class-items {
                    padding-left: 12px;
                    padding-right: 12px;
                    line-height: 32px;
                    font-size: 14px;
                    overflow: hidden;
                    margin: 0px auto;
                    box-sizing: border-box;
                    float: left;
                }
            }

            .calss-top-pc {
                display: none;
            }

            .calss-top-mobile {
                width: 98%;
                overflow: hidden;
                margin: 0px auto;
                padding: 0px;
                box-sizing: border-box;
            }
        }

        .nav-topbar {
            width: 100%;
            overflow: hidden;
            position: fixed;
            top: 0px;
            left: 0px;
            z-index: 10;
            background: url('/imgs/fade.png') top center repeat-x;

            .mobiles-nav-list {
                width: 100%;
                overflow: hidden;
                box-sizing: border-box;
                padding: 0px;
                margin: 0px auto;

                .nav-backs {
                    text-decoration: none;
                    display: block;
                    margin-left: 12px;
                    font-weight: 400;
                    overflow: hidden;
                    color: maroon;
                    line-height: 45px;
                    text-align: center;
                    float: left;
                }

                .nav-items {
                    text-decoration: none;
                    display: block;
                    margin-left: 12px;
                    font-weight: 400;
                    overflow: hidden;
                    color: maroon;
                    line-height: 45px;
                    text-align: center;
                    float: left;
                }
            }

            .nav-list {
                display: none;
            }
        }
    }
}
</style>